const CSS = ':focus-visible{box-shadow:0 0 0 4px var(--skapa-focus-ring-internal,rgb(var(--colour-neutral-1,255,255,255)));outline:2px solid var(--skapa-focus-ring-external,rgb(var(--colour-neutral-7,17,17,17)));outline-offset:4px;transition:outline .2s ease-out,box-shadow .2s ease-out}';
var FocusRing_default = { CSS, CSSWithHost: `:host(:focus-visible),${CSS}` };
export {
  FocusRing_default as default
};
